import React, { useEffect } from "react";
import { Swipeable } from 'react-swipeable'
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import PropTypes from 'prop-types';
import {
    CarouselContainer,
    CarouselSlot,
    PREV,
    NEXT,
    SlideButton,
    CarouselContainerWithArrow
} from "./components";

const getOrder = ({ index, pos, numItems }) => {
    return index - pos < 0 ? numItems - Math.abs(index - pos) : index - pos;
};
const initialState = { pos: 0, sliding: false, dir: NEXT };

export default function Carousel(props) {

    const [state, dispatch] = React.useReducer(reducer, initialState);
    const timeoutRef = React.useRef(null);

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        if (props.isAutoCarousel) {
            resetTimeout();
            timeoutRef.current = setTimeout(() => {
                slide(NEXT);
                props.changeCurrentIndex(NEXT);
            }, 6000);

            return () => {
                resetTimeout();
            };
        }
    }, [props.currentIndex]);

    const slide = dir => {
        dispatch({ type: dir, numItems: props.numItems });
        setTimeout(() => {
            dispatch({ type: "stopSliding" });
        }, 50);
    };

    const config = {
        onSwipedLeft: () => slide(NEXT),
        onSwipedRight: () => slide(PREV),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true
    };

    return (
        <React.Fragment>
            {props.showArrow ? <div className="d-flex justify-content-center align-items-center">
                {props.currentIndex > props.noOfCardDispalyed && <SlideButton onClick={() => { slide(PREV); props.changeCurrentIndex(PREV); }} float="left" left={15} marginTop={props.topPosition} width={props.iconWidth} height={props.iconWidth}>
                    <ArrowBackIosOutlinedIcon htmlColor="grey" />
                </SlideButton>}
                <Swipeable {...config} style={{ transform: "translateX(0%)", position: "relative" }}>
                    <CarouselContainerWithArrow dir={state.dir} sliding={state.sliding}>
                        {props.items.map((item, index) => (
                            <CarouselSlot
                                key={index}
                                order={getOrder({ index: index, pos: state.pos, numItems: props.numItems })}
                            >
                                {item}
                            </CarouselSlot>
                        ))}
                    </CarouselContainerWithArrow>
                </Swipeable>
                {(props.isAutoCarousel || props.currentIndex < props.items.length) && <SlideButton onClick={() => { slide(NEXT); props.changeCurrentIndex(NEXT); }} float="right" right={0} marginTop={props.topPosition} width={props.iconWidth} height={props.iconWidth}>
                    <ArrowForwardIosOutlinedIcon htmlColor="grey" />
                </SlideButton>}
            </div> :
                <Swipeable {...config}>
                    <CarouselContainer dir={state.dir} sliding={state.sliding}>
                        {props.items.map((item, index) => (
                            <CarouselSlot
                                key={index}
                                order={getOrder({ index: index, pos: state.pos, numItems: props.numItems })}
                                className="carouselItem carrier-img"
                            >
                                {item}
                            </CarouselSlot>
                        ))}
                    </CarouselContainer>
                </Swipeable>
            }
        </React.Fragment>
    );
};

function reducer(state, { type, numItems }) {
    switch (type) {
        case "reset":
            return initialState;
        case PREV:
            return {
                ...state,
                dir: PREV,
                sliding: true,
                pos: state.pos === 0 ? numItems - 1 : state.pos - 1
            };
        case NEXT:
            return {
                ...state,
                dir: NEXT,
                sliding: true,
                pos: state.pos === numItems - 1 ? 0 : state.pos + 1
            };
        case "stopSliding":
            return { ...state, sliding: false };
        default:
            return state;
    }
}

Carousel.propTypes = {
    items: PropTypes.array.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Widgets/AutoSwipeCarousel/AutoSwipeCarousel.js